export enum RemoteActionType {
  REMOTE_OPEN = 'RemoteOpen',
  RESET_DEVICE = 'ResetDevice',
  RESET_OPERATOR = 'ResetOperator',
  CLEAR_ERROR_LOG = 'ClearErrorLog',
  REFRESH_DATA = 'RefreshData',
  REMOTE_LOCK = 'RemoteLock',
  REMOTE_UNLOCK = 'RemoteUnlock',
}
